import { render } from "./GeneratePDF.vue?vue&type=template&id=27ee3e39&scoped=true"
import script from "./GeneratePDF.vue?vue&type=script&lang=js"
export * from "./GeneratePDF.vue?vue&type=script&lang=js"

import "./GeneratePDF.vue?vue&type=style&index=0&id=27ee3e39&scoped=true&lang=css"

import exportComponent from "d:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ee3e39"]])

export default __exports__